import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import {
    DEFAULT_SELECTED_LABELS,
    IndustryOverviewEntry, AVAILABLE_INDUSTRIES_DATASTRUCT
} from '../../ProductSearch/ListConfiguration/InfoConverstion';
import { Industry } from '../../ProductSearch/ListConfiguration/listconfigurator/listconfigurator.component';

@Injectable({
    providedIn: 'root'
})
export class ListConfiguratorFormService {

    constructor(private _formBuilder: FormBuilder) {}

    /**
     * Initializes all form groups for the configurator.
     * @param initialStates A boolean array representing the initial checked states.
     * @param companyInfos An array of company info rows.
     * @param initialQuantity The initial quantity value.
     */
    createConfiguratorForms(initialStates: boolean[], companyInfos: {label: string, category: string}[], initialQuantity: number): {
        branchFormGroup: FormGroup,
        regionFormGroup: FormGroup,
        companyInfosGroup: FormGroup,
        quantityFormGroup: FormGroup
    } {
        const branchFormGroup = this._formBuilder.group({
            branchCtrl: new FormControl<Industry | null>(null, Validators.required)
        });

        const regionFormGroup = this._formBuilder.group({
            states: this._formBuilder.array(initialStates, [atLeastOneSelectedValidator]),
            minimum: this._formBuilder.control(null)
        });

        const companyInfosGroup = this._formBuilder.group({
            companyInfos: this._formBuilder.array(
                companyInfos.map(info => DEFAULT_SELECTED_LABELS.includes(info.label)),
                [atLeastOneSelectedValidator],),
            minimum: this._formBuilder.control(null)
        });

        const quantityFormGroup = this._formBuilder.group({
            quantity: [initialQuantity, Validators.required]
        });

        return { branchFormGroup, regionFormGroup, companyInfosGroup, quantityFormGroup };
    }

    /**
     * Filters industries based on the input string for autocomplete.
     * @param name The input string from the autocomplete.
     */
    filterIndustries(name: string): IndustryOverviewEntry[] {
        const filterValue = name.toLowerCase();
        return AVAILABLE_INDUSTRIES_DATASTRUCT.filter(option =>
            option.name.toLowerCase().includes(filterValue)
        );
    }

}

/**
 * Custom validator to ensure at least one checkbox in a FormArray is selected.
 */
export function atLeastOneSelectedValidator(formArray: AbstractControl): ValidationErrors | null {
    const isAnySelected = (formArray.value as boolean[]).some(selected => selected);
    return isAnySelected ? null : { atLeastOne: true };
}